var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "label",
    {
      staticClass: "switch-container font-weight-bold",
      class: [_vm.size, { disabled: _vm.disabled }],
    },
    [
      _c("div", { staticClass: "switch" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.currentCheckedValue,
              expression: "currentCheckedValue",
            },
          ],
          attrs: { disabled: _vm.disabled, type: "checkbox" },
          domProps: {
            value: _vm.currentCheckedValue,
            checked: Array.isArray(_vm.currentCheckedValue)
              ? _vm._i(_vm.currentCheckedValue, _vm.currentCheckedValue) > -1
              : _vm.currentCheckedValue,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.currentCheckedValue,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = _vm.currentCheckedValue,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.currentCheckedValue = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.currentCheckedValue = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.currentCheckedValue = $$c
              }
            },
          },
        }),
        _c("span", { staticClass: "slider round" }),
      ]),
      _vm._t("switch-text", function () {
        return [
          _c("span", { staticClass: "switch-text" }, [
            _vm._v(" " + _vm._s(_vm.textDescription) + " "),
          ]),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }